import React from "react";
import { colors } from "../../../../themes/Colors";
import { IconOnlyButton } from "../../../common-components";

const TabNavigator = ({
  selected,
  onTaskClick,
  onOffenceClick,
  onVehicleClick,
  onBuzzClick,
  onProfileClick,
}) => {
  return (
    <div
      style={{
        height: 80,
        backgroundColor: colors.primaryOrange,
        width: "100%",
        WebkitBoxShadow: "-5px 5px 15px -1px #00000070",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
        alignItems: "center",
        // borderRadius: "100%",
        position: "absolute",
        bottom: -15,
        paddingBottom: 10,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        zIndex: 11,
      }}
    >
      <div
        style={{
          // position: "absolute",
          // top: selected === "product" ? -10 : 0,
          transition: "all 0.3s",
        }}
      >
        <div
          style={{
            padding: selected === "buzz" ? 10 : 0,
            backgroundColor: selected === "buzz" ? colors.orangeDark : null,
            borderRadius: 8,
            WebkitBoxShadow:
              selected === "buzz" ? "-5px 5px 15px -1px #00000070" : null,
            transition: "all 0.3s",
          }}
        >
          <IconOnlyButton
            iconImage={
              selected === "buzz"
                ? require(".././../../../images/material-icon/whiteBee.png")
                : require(".././../../../images/material-icon/whiteBee.png")
            }
            height={40}
            width={40}
            onClick={onBuzzClick}
            marginBottom={selected === "buzz" ? 40 : 0}
          />
        </div>
      </div>
      <div
        style={{
          // position: "absolute",
          // top: selected === "profile" ? -10 : 10,
          // right: selected === "profile" ? 50 : 40,
          transition: "all 0.3s",
        }}
      >
        <div
          style={{
            padding: selected === "task" ? 10 : 0,
            backgroundColor: selected === "task" ? colors.orangeDark : null,
            borderRadius: 8,
            WebkitBoxShadow:
              selected === "task" ? "-5px 5px 15px -1px #00000070" : null,
            transition: "all 0.3s",
            opacity: 0.5,
          }}
        >
          <IconOnlyButton
            iconImage={
              selected === "task"
                ? require(".././../../../images/material-icon/whiteBuzz.png")
                : require(".././../../../images/material-icon/whiteBuzz.png")
            }
            height={40}
            width={40}
            onClick={onTaskClick}
            marginBottom={selected === "task" ? 40 : 0}
          />
        </div>
      </div>
      <div
        style={{
          // position: "absolute",
          // top: selected === "list" ? -10 : 10,
          // left: selected === "list" ? 50 : 40,
          transition: "all 0.3s",
        }}
      >
        <div
          style={{
            padding: selected === "offence" ? 10 : 0,
            backgroundColor: selected === "offence" ? colors.orangeDark : null,
            borderRadius: 8,
            WebkitBoxShadow:
              selected === "offence" ? "-5px 5px 15px -1px #00000070" : null,
            transition: "all 0.3s",
            width: 50,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            opacity: 0.5,
          }}
        >
          <IconOnlyButton
            iconImage={
              selected === "offence"
                ? require(".././../../../images/material-icon/whiteOffence.png")
                : require(".././../../../images/material-icon/whiteOffence.png")
            }
            height={40}
            width={40}
            onClick={onOffenceClick}
            // label={"LIST"}
            labelColor={colors.secondaryDarkBlue}
            bottom={10}
            marginBottom={selected === "offence" ? 40 : 0}
            // widthScreen={600}
          />
        </div>
      </div>
      <div
        style={{
          // position: "absolute",
          // top: selected === "buzz" ? -10 : 0,
          transition: "all 0.3s",
        }}
      >
        <div
          style={{
            padding: selected === "vehicle" ? 10 : 0,
            backgroundColor: selected === "vehicle" ? colors.orangeDark : null,
            borderRadius: 8,
            WebkitBoxShadow:
              selected === "vehicle" ? "-5px 5px 15px -1px #00000070" : null,
            transition: "all 0.3s",
            // opacity: 0.5,
          }}
        >
          <IconOnlyButton
            iconImage={
              selected === "vehicle"
                ? require(".././../../../images/material-icon/whiteVehicle.png")
                : require(".././../../../images/material-icon/whiteVehicle.png")
            }
            height={40}
            width={40}
            onClick={onVehicleClick}
            marginBottom={selected === "vehicle" ? 40 : 0}
          />
        </div>
      </div>
      <div
        style={{
          // position: "absolute",
          // top: selected === "buzz" ? -10 : 0,
          transition: "all 0.3s",
        }}
      >
        <div
          style={{
            padding: selected === "profile" ? 10 : 0,
            backgroundColor: selected === "profile" ? colors.orangeDark : null,
            borderRadius: 8,
            WebkitBoxShadow:
              selected === "profile" ? "-5px 5px 15px -1px #00000070" : null,
            transition: "all 0.3s",
          }}
        >
          <IconOnlyButton
            iconImage={
              selected === "profile"
                ? require(".././../../../images/icons/pofileWhite.png")
                : require(".././../../../images/icons/pofileWhite.png")
            }
            height={40}
            width={40}
            onClick={onProfileClick}
            marginBottom={selected === "profile" ? 40 : 0}
          />
        </div>
      </div>
    </div>
  );
};

export default TabNavigator;
